import React, { useEffect, useState } from "react";
import { Bell, Check, CheckCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, LoadingBlock, EmptyState, formatDateTime } from "@/components/Common";
import { Link } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";
import api from "@/lib/api";

export default function Notifications() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  const [items, setItems] = useState(null);
  const load = () => api.get("/notifications").then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  if (items === null) return <LoadingBlock />;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-2xl font-medium text-white">{L("Notifiche", "Notifications", "Benachrichtigungen")}</h2>
        <Button variant="outline" className="border-white/20 text-white" onClick={markAll} data-testid="mark-all-read"><CheckCheck className="h-4 w-4 mr-1.5" />{L("Segna tutte come lette", "Mark all as read", "Alle als gelesen markieren")}</Button>
      </div>
      {items.length === 0 ? <EmptyState icon={Bell} title={L("Nessuna notifica", "No notifications", "Keine Benachrichtigungen")} /> : (
        <div className="space-y-2">
          {items.map((n) => (
            <Card key={n.id} className={`p-4 flex items-start justify-between gap-4 ${!n.read ? "border-cyanx/30" : ""}`} data-testid={`notification-${n.id}`}>
              <div className="flex items-start gap-3">
                <span className={`mt-1 h-2 w-2 rounded-full ${n.read ? "bg-slate-600" : "bg-cyanx"}`} />
                <div>
                  <p className="text-sm text-white">{n.title}</p>
                  <p className="text-sm text-slate-400">{n.message}</p>
                  <p className="text-xs text-slate-600 mt-1">{formatDateTime(n.created_at)}
                    {n.case_id && <> · <Link to={`/portal/cases/${n.case_id}`} className="text-cyanx">{L("Apri pratica", "Open case", "Fall öffnen")}</Link></>}
                  </p>
                </div>
              </div>
              {!n.read && <Button size="sm" variant="ghost" className="text-slate-400" onClick={() => markRead(n.id)}><Check className="h-4 w-4" /></Button>}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
